const translations = {
  login: {
    label: {
      email: 'E-Mail',
    }
  }
};

export default translations;